var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center"},[_c('app-avatar',{key:_vm.value ? _vm.value.id : Date.now(),attrs:{"border":true,"img":_vm.value ? _vm.value.full_url : _vm.defaultImg,"avatar-class":"avatars-w-60","title":_vm.rowData.name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }